import { useTheme } from '../../../../../../hooks/useTheme';
import styles from '../Disco.module.css';

interface DotIndicatorProps {
  current: number;
  total: number;
}

export function DotIndicator({ current, total }: DotIndicatorProps) {
  const theme = useTheme();
  const activeColor = theme.buttonsPrimaryDefault?.backgroundColor;

  return (
    <div className={styles.dotIndicator}>
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          className={`${styles.dot} ${i === current ? styles.dotActive : ''}`}
          style={
            i === current && activeColor
              ? { background: activeColor }
              : undefined
          }
        />
      ))}
    </div>
  );
}
